import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

//global reveal triggers
//When trigger class is position from the bottom in view toggle the "revealed" class
//what happens when that class is added is up to the css
const reveal = gsap.utils.toArray('.js-trigger-reveal');
reveal.forEach(reveal => {

    // Content Reveal Animation
    ScrollTrigger.create({
        start: "top bottom-=35%",
        trigger: reveal,
        onEnter: ({progress, direction, isActive}) => reveal.classList.add('revealed'),
        //onLeaveBack: ({progress, direction, isActive}) => reveal.classList.remove('revealed'),
        //markers: {startColor: "blue", endColor: "blue", fontSize: "18px", fontWeight: "bold", indent: 20}
    });

});



// Sticky Anchor Navigation for history timeline
const stickyNav = document.querySelector('.timeline-nav');

if( stickyNav ){

    //pin the nav
    ScrollTrigger.create({
        trigger: '.pattern--timeline',
        pin: stickyNav,
        start: "top top",
        end: "bottom bottom-=250px",
        // onEnter: ({progress, direction, isActive}) => {
        //     stickyNav.classList.add('stick');
        // },
        // onLeaveBack: ({progress, direction, isActive}) => {
        //     stickyNav.classList.remove('stick');
        // },
        //markers: {startColor: "blue", endColor: "green", fontSize: "18px", fontWeight: "bold", indent: 20 }
    });

    let jumpLinks = gsap.utils.toArray(".timeline-nav a");

    jumpLinks.forEach( a => {
        let section = document.querySelector(a.getAttribute("href"));
        //console.log(section);

        ScrollTrigger.create({
            trigger: section,
            start: "top top+=232px",
            end: "bottom top+=200px",
            onToggle: self => {
                if(self.isActive){
                    jumpLinks.forEach(el => el.classList.remove("active"));
                    a.classList.add("active");
                }
                else{
                    a.classList.remove("active");
                }
            },
            //markers: {startColor: "purple", endColor: "orange", fontSize: "18px", fontWeight: "bold", indent: 20 }
        });
    });
}
